import _ from 'lodash'
import { createSelector } from 'reselect'
import { isGroupUser } from 'utils/user'
import { applyFiltersToList } from './helpers'
import { getUsersList } from './Lists'

export const getCurrentUserProfileId = (state) => state.global.user.id

export const getCurrentUserProfile = createSelector(
  [getCurrentUserProfileId, getUsersList],
  (id, users) => _.find(users, { id })
)

export const getUsers = createSelector(
  [getUsersList, getCurrentUserProfile],
  (users, currentUser) => {
    if (!users || !currentUser) return null
    return _(users)
      .filter({ deleted: false })
      .filter((user) =>
        isGroupUser(currentUser.role) ? isGroupUser(user.role) : true
      )
      .value()
  }
)

// CARE-925: the list/carers list may include users that should be hidden
export const getHomeUsers = createSelector([getUsersList], (users) => {
  if (!users) return null
  return _.filter(users, { hidden: false })
})

export const chooseSelectedUser = createSelector(
  [getHomeUsers, getCurrentUserProfile],
  (users, currentUser) => {
    if (!users || !currentUser) return null
    const active = _(users)
      .filter({ active: true })
      .filter((user) =>
        isGroupUser(currentUser.role) ? isGroupUser(user.role) : true
      )
      .sortBy('name.first')
      .value()
    if (!active || !active.length) return null
    return active[0].id
  }
)

const getCurrentFilters = (state) => state.global.filters.carers
const getSortType = (state) => state.global.sortTypes.carers

export const sortFilteredUsers = createSelector(
  [getHomeUsers, getCurrentFilters, getSortType],
  (users, filters, sortType) => {
    if (!users) return null
    if (!filters) return users

    return applyFiltersToList(filters, users)
  }
)

export const getUserFilters = createSelector([getUsers], (users) => {
  if (!users) return null

  const active = _.filter(users, { active: true })
  const inactive = _.filter(users, { active: false })

  return {
    active: {
      label: 'Status',
      filters: [
        { label: 'Active', value: true, count: active.length },
        { label: 'Inactive', value: false, count: inactive.length }
      ]
    }
  }
})
